import { Box, Link, SpaceBetween, Spinner } from "@amzn/awsui-components-react";
import { FC, useEffect, useState } from "react";
import { MapEngineHandle } from "../../react";

export interface SpritesPanelProps {
    handle: MapEngineHandle | null;
}

/**
 * Shows the current stylesheet's sprite sheet (the `sprite` URL from the style).
 * Renders the sprite PNG and links to the sprite JSON. Ported from 1.0 Sprites.
 */
const SpritesPanel: FC<SpritesPanelProps> = ({ handle }) => {
    const [spriteBase, setSpriteBase] = useState<string | null | undefined>(undefined);

    useEffect(() => {
        const style = handle?.engine()?.getStyle();
        // `sprite` may be absent; normalize to a base URL (without extension).
        setSpriteBase((style?.sprite as string) ?? null);
    }, [handle]);

    if (spriteBase === undefined) return <Spinner />;
    if (!spriteBase) return <Box>This stylesheet has no sprite sheet.</Box>;

    const png = `${spriteBase}.png`;
    const json = `${spriteBase}.json`;

    return (
        <SpaceBetween size="s">
            <Box variant="small">Sprite sheet for the current stylesheet.</Box>
            <img
                src={png}
                alt="Stylesheet sprite sheet"
                style={{ maxWidth: "100%", border: "1px solid #e9ebed", background: "#f7f7f7" }}
            />
            <SpaceBetween direction="horizontal" size="xs">
                <Link external href={png}>
                    Sprite PNG
                </Link>
                <Link external href={json}>
                    Sprite JSON
                </Link>
            </SpaceBetween>
        </SpaceBetween>
    );
};

export default SpritesPanel;
